export enum PersonalizationKeysEnum {
  LastLayoutId = 'LastLayoutId',
  LastStructureId = 'LastStructureId',
  LayoutState =  'LayoutState',
  LastProject = 'LastProject',
  LayoutColumnOrder = 'LayoutColumnOrder',
  Fault_PlanSplit_LeftViewSize = "Fault_PlanSplit_LeftViewSize",
  Fault_PlanSplit_RightViewSize = "Fault_PlanSplit_RightViewSize",
  FaultGridLineAmount = 'FaultGridLineAmount',

  Fault_LeftToggleGroup = "Fault_LeftToggleGroup",
  Fault_RightToggleGroup = "Fault_RightToggleGroup",

  CurrentLayoutFavoriteFilterMode = "mm.CurrentLayoutFavoriteFilterMode",
  CurrentLayoutDisplayField = "mm.CurrentLayoutDisplayField",
  LayoutTypeSorting = "mm.LayoutTypeSorting",

  RecentlyUsedCompanies = "mm.RecentlyUsedCompanies",
  RecentlyUsedCrafts = "mm.RecentlyUsedCrafts",
  RecentlyUsedOrders = "mm.RecentlyUsedOrders",

  FieldConfig = "FieldConfig",
  FaultFieldsMemoryValues = "FaultFieldsMemoryValues",

  SyncResult = "SyncResult",

  CompaniesGrid = "MM.CompaniesGrid",
  CraftsGrid = "MM.CraftsGrid",
  UserDefinedsGrid1 = "MM.UserDefinedsGrid1",
  UserDefinedsGrid2 = "MM.UserDefinedsGrid2",

  LastBimPlanId = "mm.LastBimPlanId",

  LastUsedInternalToAddresses = "LastUsedInternalToAddresses",
  LastUsedInternalCcAddresses = "LastUsedInternalCcAddresses",
  LastUsedInternalBccAddresses = "LastUsedInternalBbcAddresses",

  SearchBy = "SearchBy"
}
